import { SquarePen } from 'lucide-react'

import { BrokerActionButton } from '@/components/ui/BrokerActionButton'
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet'
import { BrokerNoteForm } from './BrokerNoteForm'
import { useBrokerNote } from './useBrokerNote'

/** The mobile bar's note icon; opens the note form in a bottom sheet. */
export function BrokerNoteSheet({ brokerName }: { brokerName: string }) {
  const note = useBrokerNote(brokerName)
  const label = `Leave ${note.firstName} a note`

  return (
    <Sheet open={note.open} onOpenChange={note.onOpenChange}>
      <SheetTrigger asChild>
        <BrokerActionButton aria-label={label}>
          <SquarePen />
        </BrokerActionButton>
      </SheetTrigger>
      <SheetContent side="bottom" className="gap-0 pb-6">
        <SheetHeader>
          <SheetTitle>{label}</SheetTitle>
          <SheetDescription>{note.firstName} gets it by email and will get back to you.</SheetDescription>
        </SheetHeader>
        <div className="px-4">
          <BrokerNoteForm
            brokerFirstName={note.firstName}
            draft={note.draft}
            onDraftChange={note.setDraft}
            onSubmit={note.send}
            isPending={note.isPending}
            isError={note.isError}
          />
        </div>
      </SheetContent>
    </Sheet>
  )
}
